import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TimelineLite} from "gsap";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {IStickyObject} from "../views/StickyWildsView";


export class HorribleHeroesStickyWildWin implements GameRoundPresentation {
    private readonly _reelId: number;

    /**
     * @constructs
     * @param reelId
     * @param duration
     */
    constructor(reelId: number) {
        this._reelId = reelId;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData): TimelineLite | null {
        if (data.wildMultipliers[this._reelId])
            if (this._reelId > 0) {
                const stickyWildWinObj: IStickyObject = HorribleHeroesGameModuleConfig.stickyWilds.addDelayToReel(this._reelId);
                if (stickyWildWinObj.isSticky) {
                    const duration = stickyWildWinObj.duration;
                    const tl: TimelineLite = new TimelineLite();
                    tl.add(() => {
                    }, duration);
                    return tl;
                }
            }
        return null;
    }

}